export const columns = [
	{
		key: 'deviceNo',
		name: '设备通讯编号',
		fixed: 'left',
		tooltip: true,
	},
	{
		key: 'designNo',
		name: '外观编号',
		tooltip: true,
	},
	{
		key: 'waterRegionName',
		name: '所属区域',
		tooltip: true,
	},
	{
		key: 'userTypeId',
		name: '客户类型',
		slot: 'userTypeId',
		tooltip: true,
	},
	{
		key: 'caliber',
		name: '口径',
		tooltip: true,
	},
	{
		key: 'userName',
		name: '客户名称',
		tooltip: true,
	},
	{
		key: 'eventLevel',
		name: '报警等级',
		slot: 'eventLevel',
	},
	{
		key: 'comparisonValue',
		name: '报警阈值',
		slot: 'comparisonValue',
		width: 160,
	},
	{ key: 'pushWechat', name: '微信推送', slot: 'pushWechat', tooltip: true, dragDisable: true, disabledSelect: true },
	{ key: 'pushSms', name: '短信推送', slot: 'pushSms', tooltip: true, dragDisable: true, disabledSelect: true },
	{ key: 'pushPage', name: '页面推送', slot: 'pushPage', tooltip: true, dragDisable: true, disabledSelect: true },
	{ key: 'pushVoice', name: '声音警告', slot: 'pushVoice', tooltip: true, dragDisable: true, disabledSelect: true },
]
